export default __webpack_public_path__ + "static/media/foot-calendar.26f305d8.svg";